<template>
	<div 
		class="statsBtn "
	>
		<div>
			<h3>Переглянути статистику</h3>
			<small>
				Дані за тиждень, місяць та навіть роки! 
				А також інструменти для порівняння та аналізу даних.
			</small>
		</div>
	</div>
</template>

<script setup>

</script>

<style scoped>

.statsBtn {
	width: 100%;
	aspect-ratio: 2 / 1;

	border-radius: 10px;

	overflow: hidden;

	background: linear-gradient(to top, #202020 0%, #202020ee 40%, #00000040 100%), 
				url(https://media.istockphoto.com/id/1407983911/photo/forex-diagrams-and-stock-market-rising-lines-with-numbers.jpg?s=612x612&w=0&k=20&c=zas1h6LR6v2iCvE7SWnVoZ_s7ZSiboN45UK0d5oMWac=);

	background-size: cover;
	background-position: center;

	color: white;

	display: flex;
	align-items: end;

	border: 1px solid var(--color-border);

	cursor: pointer;
	user-select: none;

	transition: all 0.3s ease;
}

.statsBtn > div {
	padding: 1em;
}

.statsBtn:hover {
	box-shadow: 0 2px 10px #202020aa;
	translate: 0 -2px;
}
</style>